module.exports = __webpack_public_path__ + "media/audio112.5810ef15.mp3";